import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import MainContainer from '@/components/generals/main-container'
import EditorialGrid from '@/components/generals/editorial-grid'
import Button from '@/components/elements/button'
import Editable from '@/components/elements/editable'
import { profile } from '@/constants/profile'

const EXPLORING_LINKS: Record<string, string> = {
    'Running Hermes Agent on an Ubuntu server': '/lab/hermes-agent-deployment',
    'Telegram as an interface for AI workflows': '/lab/telegram-agent-workflows',
    'Memory systems for self-hosted AI agents': '/lab/self-hosted-memory-systems',
    'Autonomous agents with clear, auditable boundaries': '/lab/autonomous-agent-loops'
}

const AboutPreview: FC = (): ReactNode => {
    return (
        <section id='about' aria-labelledby='about-title' className='border-y border-border bg-surface'>
            <MainContainer className='py-20 md:py-32'>
                <EditorialGrid className='gap-y-10'>
                    <div className='col-span-4 md:col-span-3'>
                        <p className='flex items-center gap-3 font-mono text-label uppercase text-muted-foreground'>
                            <span aria-hidden='true' className='size-1.5 bg-brand' />
                            <span className='text-foreground'>04</span>
                            About
                        </p>
                    </div>

                    <div className='col-span-4 flex flex-col gap-10 md:col-span-9 lg:col-span-8'>
                        <h2 id='about-title' className='font-heading text-headline [font-weight:380]'>
                            An engineer&apos;s notebook, <em className='text-brand'>kept in public</em>.
                        </h2>

                        <EditorialGrid className='gap-y-10 md:grid-cols-8'>
                            <div className='col-span-4 flex flex-col gap-5 md:col-span-5'>
                                <p className='text-lede'>
                                    {profile.introduction[0]}
                                </p>

                                <p className='text-body text-muted-foreground'>
                                    Written and maintained by <Editable value={profile.name} className='text-foreground' />,
                                    {' '}{profile.role.toLowerCase()}.
                                </p>

                                <Button href='/about' variant='secondary' icon='arrow' className='mt-2 self-start'>
                                    More about me
                                </Button>
                            </div>

                            <div className='col-span-4 md:col-span-3'>
                                <p className='font-mono text-label uppercase text-muted-foreground'>Currently exploring</p>

                                <ul className='mt-4 border-t border-border'>
                                    {profile.currentlyExploring.map((item) => {
                                        const href = EXPLORING_LINKS[item]

                                        return (
                                            <li key={item} className='flex gap-3 border-b border-border py-3 text-[0.9375rem] leading-snug'>
                                                <span aria-hidden='true' className='mt-[0.45em] size-1.5 shrink-0 bg-brand' />
                                                {href ? (
                                                    <Link href={href} className='link-underline hover:text-brand'>{item}</Link>
                                                ) : (
                                                    <span>{item}</span>
                                                )}
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </EditorialGrid>
                    </div>
                </EditorialGrid>
            </MainContainer>
        </section>
    )
}

export default AboutPreview
